import { Box, BoxProps, Container } from "@chakra-ui/react";

export const PageContent = (props: BoxProps) => (
  <Box as="main" py="4" {...props}>
    <Container maxW="7xl">
      <Box bg="white" p="6" rounded="lg" shadow="base">
        {props.children}
      </Box>
    </Container>
  </Box>
);
